import { Trans } from '@lingui/react/macro'
import { Box, Group, Image, Stack, Text, UnstyledButton } from '@mantine/core'
import { IconChevronRight } from '@tabler/icons-react'
import faceImage from '$src/assets/images/face.png'
import styles from './StatusTile.module.css'
import type { GroupedServices } from './utils'

const COLOR = { overdue: '#fa5252', dueSoon: '#f59f00', onTrack: '#2f9e44' }

export function StatusTile({
  counts,
  onOpen,
}: {
  counts: GroupedServices['counts']
  onOpen: () => void
}) {
  const attention = counts.overdue + counts.dueSoon
  const allGood = attention === 0
  const metricColor = counts.overdue
    ? COLOR.overdue
    : counts.dueSoon
      ? COLOR.dueSoon
      : COLOR.onTrack

  return (
    <UnstyledButton className={styles.tile} onClick={onOpen}>
      <Stack gap="sm" h="100%" justify="space-between">
        <Group
          justify="space-between"
          wrap="nowrap"
          align="flex-start"
          gap="xs"
        >
          <Stack gap={8} style={{ minWidth: 0 }}>
            <Text className={styles.eyebrow}>
              <Trans>Maintenance status</Trans>
            </Text>

            <Group align="flex-end" gap="sm" wrap="nowrap">
              <Text className={styles.metric} style={{ color: metricColor }}>
                {allGood ? counts.onTrack : attention}
              </Text>
              <Text size="sm" fw={700} c="brandBrown.7" pb={5}>
                {allGood ? (
                  <Trans>On track</Trans>
                ) : (
                  <Trans>Needs attention</Trans>
                )}
              </Text>
            </Group>

            <Group gap="md">
              {counts.overdue > 0 && (
                <Dot color={COLOR.overdue} n={counts.overdue} />
              )}
              {counts.dueSoon > 0 && (
                <Dot color={COLOR.dueSoon} n={counts.dueSoon} />
              )}
              {counts.onTrack > 0 && (
                <Dot color={COLOR.onTrack} n={counts.onTrack} />
              )}
            </Group>
          </Stack>

          <Image
            src={faceImage}
            alt="Markku"
            w={48}
            h={48}
            fit="contain"
            style={{ flexShrink: 0 }}
          />
        </Group>

        <Group gap={2} wrap="nowrap">
          <Text className={styles.cta}>
            <Trans>See details</Trans>
          </Text>
          <IconChevronRight
            size={14}
            color="var(--mantine-color-brandOrange-7)"
          />
        </Group>
      </Stack>
    </UnstyledButton>
  )
}

function Dot({ color, n }: { color: string; n: number }) {
  return (
    <Group gap={5} wrap="nowrap">
      <Box w={9} h={9} style={{ borderRadius: '50%', background: color }} />
      <Text size="xs" fw={700} c="brandBrown.7">
        {n}
      </Text>
    </Group>
  )
}
